var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import searchLogPerformanceConstants from "./SearchLogPerformanceConstants.js";
const defaultState = {
  expSearchStart: 0,
  expSearchMainFunctionality: 0,
  expSearchFullLoad: 0,
  flightSearchStart: 0,
  flightSearchMainFunctionality: 0,
  flightSearchFullLoad: 0
};
const SearchLogPerformanceReducer = (state = defaultState, actionResult) => {
  switch (actionResult.type) {
    case searchLogPerformanceConstants.EXP_SEARCH_LOAD_START:
      return __spreadProps(__spreadValues({}, state), {
        expSearchStart: actionResult.timestampMilliSeconds
      });
    case searchLogPerformanceConstants.EXP_SEARCH_MAIN_FUNCTIONALITY:
      return __spreadProps(__spreadValues({}, state), {
        expSearchMainFunctionality: actionResult.timestampMilliSeconds
      });
    case searchLogPerformanceConstants.EXP_SEARCH_FULL_LOAD:
      return __spreadProps(__spreadValues({}, state), {
        expSearchFullLoad: actionResult.timestampMilliSeconds
      });
    case searchLogPerformanceConstants.FLIGHT_SEARCH_LOAD_START:
      return __spreadProps(__spreadValues({}, state), {
        flightSearchStart: actionResult.timestampMilliSeconds
      });
    case searchLogPerformanceConstants.FLIGHT_SEARCH_MAIN_FUNCTIONALITY:
      return __spreadProps(__spreadValues({}, state), {
        flightSearchMainFunctionality: actionResult.timestampMilliSeconds
      });
    case searchLogPerformanceConstants.FLIGHT_SEARCH_FULL_LOAD:
      return __spreadProps(__spreadValues({}, state), {
        flightSearchFullLoad: actionResult.timestampMilliSeconds
      });
    default:
      return state;
  }
};
export {
  SearchLogPerformanceReducer,
  SearchLogPerformanceReducer as default
};
//# sourceMappingURL=SearchLogPerformanceReducers.js.map
